import { combineReducers } from '@reduxjs/toolkit';
import projectsReducer from './projectsSlice';

export default function dashboardReducer() {
  return combineReducers({
    projects: projectsReducer,
  });
}
